module.exports = __webpack_public_path__ + "static/media/Bokiizy.21224fe2.jpg";